import { Link } from "react-router-dom";
import { AlertCircle, ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center bg-brand-dark px-4 text-center text-white">
      <div className="rounded-full bg-brand-accent/10 p-6 text-brand-accent mb-6 border-glow">
        <AlertCircle className="h-16 w-16" />
      </div>
      <h1 className="font-display text-4xl font-extrabold tracking-tight sm:text-5xl">
        404 - Siden blev ikke fundet
      </h1>
      <p className="mt-4 max-w-md text-sm sm:text-base text-gray-400 leading-relaxed">
        Siden, du leder efter, findes desværre ikke eller er blevet flyttet. Brug menuen i toppen eller knappen nedenfor til at komme tilbage på sporet.
      </p>
      <div className="mt-10">
        <Link
          to="/"
          className="inline-flex items-center gap-2 rounded bg-brand-accent px-6 py-3 text-xs font-bold uppercase tracking-wider text-white transition-colors hover:bg-brand-accent-hover"
        >
          <ArrowLeft className="h-4 w-4" />
          Tilbage til forsiden
        </Link>
      </div>
    </div>
  );
}
